export class Geocoder {
    urls = {
        url_geocode_forward: "/servlet/geocode",
        url_geocode_reverse: "/servlet/reversegeocode",
    };
    asyncFlag = true;

    query(options, callback) {
        $.ajax({
            async: this.asyncFlag,
            type: "GET",
            url: this.urls["url_geocode_forward"],
            context: this,
            data: {
                query: options.query,
                proximity: options.center,
            },
            dataType: "JSON",
            success: function (response) {
                var json = {
                    results: {
                        type: "FeatureCollection",
                        query: options["query"],
                        features: [],
                    },
                };

                if (response.hasOwnProperty("features")) {
                    $(response.features).each(function () {
                        this.properties = {};
                        this.geometry = {
                            type: "Point",
                            coordinates: this.center,
                        };

                        json.results.features.push(this);
                    });
                }

                callback.call(this, json);
            },
        });
    }

    reverseQuery(location, callback) {
        $.ajax({
            async: this.asyncFlag,
            type: "GET",
            url: this.urls["url_geocode_reverse"],
            context: this,
            data: {
                lat: location["lat"],
                lng: location["lng"],
            },
            dataType: "JSON",
            success: function (response) {
                var json = {
                    type: "FeatureCollection",
                    query: [location["lng"], location["lat"]],
                    features: [],
                };

                if (response.hasOwnProperty("features")) {
                    $(response.features).each(function () {
                        this.properties = {};
                        this.geometry = {
                            type: "Point",
                            coordinates: json.query,
                        };
                        json.features.push(this);
                    });
                }

                callback.call(this, json);
            },
        });
    }

    setAsync(flag) {
        this.asyncFlag = flag;
    }
}